export default "__VITE_ASSET__745f1c7b__"